import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import TextField from 'material-ui/TextField';
import debounce from 'lodash.debounce';
const styles = {};

class ConnnectionListSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      partnerFilter: '',
    };
  }
  _updateValue(type) {
    if (this.state.partnerFilter !== this.refs[type].getValue()) {
      this.setState({ [type]: this.refs[type].getValue() }, () => {
        this.props.searchUpdate(this.state.partnerFilter);
      });
    }
  }
  render() {
    return (<TextField
      hintText="Search for a partner"
      ref="partnerFilter"
      onChange={debounce(this._updateValue.bind(this, 'partnerFilter'), 400)}
      underlineShow={false}
      hintStyle={ { marginLeft: '24px', fontSize: '12px', color: 'black' } }
      inputStyle={ {
        border: '1px solid #00bcd4',
        width: '100%',
        marginLeft: '14px',
        bottom: '-10px',
        height: '28px',
        paddingLeft: '10px',
        fontSize: '12px',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
      }}
    />);
  }
}


ConnnectionListSearch.propTypes = {
  classes: PropTypes.object,
  searchUpdate: PropTypes.func,
};

ConnnectionListSearch.defaultProps = {
  searchUpdate: console.log,
};


export default injectSheet(styles)(ConnnectionListSearch);



// WEBPACK FOOTER //
// ./src/app/components/workspace/connection-list-search.jsx